import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";
import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputArea";
import Error from "components/form/Error";
import DrawerButton from "components/form/DrawerButton";
import useAdvertisement from "hooks/useAdvertisementSubmit";
import UploaderAds from "components/image-uploader/UploaderAds";
import { FiX } from "react-icons/fi";

const AdvertisementDrawer = ({ id, isViewMode, tab }) => {
  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    errors,
    loading,
    // setExistingImageInterior1,
    interiorUrl1,
    setInteriorUrl1,
  } = useAdvertisement(id, tab);

  const handleCancelImage = () => {
    setInteriorUrl1("");
    // setExistingImageInterior1("");
  };

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        <Title register={register} title="Edit Advertisement" />
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card className="flex-grow scrollbar-hide w-full max-h-full">
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="pt-5 flex-grow scrollbar-hide w-full max-h-full pb-20">
                <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                  <div className="col-span-6">
                    <LabelArea label="Title" required />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Title"
                      name="title"
                      type="text"
                      placeholder="title"
                    />
                    <Error errorName={errors.title} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="Url" required />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Url"
                      name="url"
                      type="text"
                      placeholder="url"
                    />
                    <Error errorName={errors.url} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="Content" required />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Content"
                      name="content"
                      type="text"
                      placeholder="Content"
                      //   pattern={/^[0-9]{4}$/}
                      required={true}
                    />
                    <Error errorName={errors.content} />
                  </div>

                  <div className="col-span-12">
                    <LabelArea label={"Advertisement Image"} required />
                    {interiorUrl1 ? (
                      <div className="flex items-center gap-3">
                        <img
                          style={{
                            objectFit: "cover",
                            width: "350px",
                            height: "150px",
                            borderRadius: "5px",
                          }}
                          src={
                            process.env.REACT_APP_API_IMAGE_URL + interiorUrl1
                          }
                          alt="caricon"
                        />
                        {!isViewMode ? (
                          <FiX
                            size={20}
                            onClick={handleCancelImage}
                            style={{ cursor: "pointer" }}
                          />
                        ) : null}
                      </div>
                    ) : (
                      <UploaderAds
                        is_multiple={false}
                        folder="advertisement"
                        name_merge="ad_image_1"
                        imageUrl={interiorUrl1}
                        setImageUrl={setInteriorUrl1}
                        no_of_image={1}
                        required={true}
                      />
                    )}
                    <Error errorName={errors.ad_image_1} />
                  </div>
                </div>
              </div>

              <DrawerButton
                isSubmitting={loading}
                id={id}
                title={id ? "Update" : "Submit"}
              />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default AdvertisementDrawer;
